import {
    fnGetUrl,
} from "../axios/Api"

export const getToken = (token) => {
    const apiRequest = {
        endpoint: "/ValidateToken?sToken=" + token,
    }

    return fnGetUrl(apiRequest)
}